<template>
  <div id="app">
    <UserLogin :visible.sync="loginVisible"></UserLogin>
    <bindPhone  :visible.sync="bindVisible" :onlyBindPhone="true"/>
    <router-view/>
  </div>
</template>

<script>
import UserLogin from '@/components/UserLogin.vue';
import bindPhone from '@/components/bind-phone.vue';

export default {
  components: {
    UserLogin,
    bindPhone,
  },
  computed: {
    loginVisible() {
      return this.$store.state.loginVisible;
    },
    bindVisible() {
      return this.$store.state.bindVisible;
    },
  },
   mounted() {
      window.addEventListener('resize', this.baseResize);
  },
  methods: {
      baseResize() {
          this.$store.state.isMobile = window.innerWidth <= 1120; // 自适应
      },
  },
};
</script>
